import React from 'react';
import { LinkItem } from '../interfaces';
import { getItemTarget } from '../utils/utils';
import InternalIcon from '../../icon/internal';
import ItemIcon from './item-icon';

interface LinkItemProps {
  item: LinkItem;
  disabled: boolean;
  optionProps: React.HTMLProps<HTMLAnchorElement & HTMLSpanElement>;
}

const ExternalIcon = ({ item }: { item: LinkItem }) => {
  const { disabled, externalIconAriaLabel } = item;
  const icon = <InternalIcon variant={disabled ? 'disabled' : 'normal'} name="external" />;

  return externalIconAriaLabel ? (
    <span role="img" aria-label={externalIconAriaLabel}>
      {icon}
    </span>
  ) : (
    icon
  );
};

const LinkItem = ({ item, disabled, optionProps }: LinkItemProps) => {
  const hasIcon = !!(item.iconName || item.iconSvg || item.iconUrl);
  return (
    <a
      {...optionProps}
      href={!disabled ? item.href : undefined}
      target={getItemTarget(item)}
      rel={item.external ? 'noopener noreferrer' : undefined}
    >
      {hasIcon && <ItemIcon name={item.iconName} url={item.iconUrl} svg={item.iconSvg} alt={item.iconAlt} />}
      <span>
        {item.text} {item.external && <ExternalIcon item={item} />}
      </span>
    </a>
  );
};

export default LinkItem;
